export enum VinculosExternos {
  Home = 1,
  Youtube = 2,
  Facebook = 3,
  Soporte = 4,
  Videos = 5,
  Documentos = 6,
  LoNuevo = 7
}

export enum ProveedorLogin {
  Google = 'Google',
  Microsoft = 'Microsoft',
  Facebook = 'Facebook',
  Twitter = 'Twitter'
}

export enum KeyLocalStorage {
  ProvLogin = 'proveedorLogin',
  // AccessToken = 'accessToken',
  Sesion = 'Sesion',
  VarioTabsActivo = 'variosTabsActivo',
  VariosTabsMaestro = 'variosTabsMaestro',
  DatosDesigner = 'datosDesigner',
  Lenguaje = 'Lenguaje',
  Logeado = 'Logeado'
}

export enum KeyVentanaPreviewExcel {
  DEFAULT = 'DEFAULT',
  FASAR = 'FASAR',
  COSTOHORARIO = 'COSTOHORARIO',
  SOBRECOSTO = 'SOBRECOSTO',
  PIEINDIRECTO = 'PIEINDIRECTO'
}
